import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    clientname: {
      validations: []
    },
    PartyName: {
        validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide the number of guests' },
      ]
    },
    StartTime: {
        validations: []
    },
    EndTime: {
        validations: []
      },
      SiteName: {
          validations: []
      },
      SiteAddress: {
          validations: []
      },
      SiteCity: {
          validations: []
      },
      SitePostal: {
          validations: [
              { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
          ]
       },
        Theme: {
            validations: [
              { type: 'required', message: 'Please fill in required field.' }
            ]
          },
          Category: {
            validations: []
          },
          Operation: {
              validations: [
                { type: 'required', message: 'Please fill in required field.' }
              ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
            {
            type: 'label',
            size: 'Medium',
            label: 'Your Contact Information',
            mapping: 'headerLabel',
            customClasses: ['header']
        }
    ]
    },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number*',
            mapping: 'telnumber'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'E-mail Address*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company',
            mapping: 'clientname'
          },
        ]
      },
      {
        fields: [
            {
            type: 'label',
            size: 'Medium',
            label: 'Event Details',
            mapping: 'headerLabel',
            customClasses: ['header']
        }
    ]
    },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Name of the Event',
            mapping: 'PartyName'
        }
      ]
    },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of People*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Start Time',
            options: [
                { label: '7:30 AM', value: '07:30:00' },
                { label: '8:00 AM', value: '08:00:00' },
                { label: '8:30 AM', value: '08:30:00' },
                { label: '9:00 AM', value: '09:00:00' },
                { label: '9:30 AM', value: '09:30:00' },
                { label: '10:00 AM', value: '10:00:00' },
                { label: '10:30 AM', value: '10:30:00' },
                { label: '11:00 AM', value: '11:00:00' },
                { label: '11:30 AM', value: '11:30:00' },
                { label: '12:00 PM', value: '12:00:00' },
                { label: '12:30 PM', value: '12:30:00' },
                { label: '1:00 PM', value: '13:00:00' },
                { label: '1:30 PM', value: '13:30:00' },
                { label: '2:00 PM', value: '14:00:00' },
                { label: '2:30 PM', value: '14:30:00' },
                { label: '3:00 PM', value: '15:00:00' },
                { label: '3:30 PM', value: '15:30:00' },
                { label: '4:00 PM', value: '16:00:00' },
                { label: '4:30 PM', value: '16:30:00' },
                { label: '5:00 PM', value: '17:00:00' },
                { label: '5:30 PM', value: '17:30:00' },
                { label: '6:00 PM', value: '18:00:00' },
                { label: '6:30 PM', value: '18:30:00' },
                { label: '7:00 PM', value: '19:00:00' },
                { label: '7:30 PM', value: '19:30:00' },
                { label: '8:00 PM', value: '20:00:00' },
                { label: '8:30 PM', value: '20:30:00' },
                { label: '9:00 PM', value: '21:00:00' },
                { label: '9:30 PM', value: '21:30:00' },
                { label: '10:00 PM', value: '22:00:00' },
                { label: '10:30 PM', value: '22:30:00' },
                { label: '11:00 PM', value: '23:00:00' },
                { label: '11:30 PM', value: '23:30:00' },
            ],
            mapping: 'StartTime'
        }
    ]
    },
    {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'End Time',
            options: [
                { label: '7:30 AM', value: '07:30:00' },
                { label: '8:00 AM', value: '08:00:00' },
                { label: '8:30 AM', value: '08:30:00' },
                { label: '9:00 AM', value: '09:00:00' },
                { label: '9:30 AM', value: '09:30:00' },
                { label: '10:00 AM', value: '10:00:00' },
                { label: '10:30 AM', value: '10:30:00' },
                { label: '11:00 AM', value: '11:00:00' },
                { label: '11:30 AM', value: '11:30:00' },
                { label: '12:00 PM', value: '12:00:00' },
                { label: '12:30 PM', value: '12:30:00' },
                { label: '1:00 PM', value: '13:00:00' },
                { label: '1:30 PM', value: '13:30:00' },
                { label: '2:00 PM', value: '14:00:00' },
                { label: '2:30 PM', value: '14:30:00' },
                { label: '3:00 PM', value: '15:00:00' },
                { label: '3:30 PM', value: '15:30:00' },
                { label: '4:00 PM', value: '16:00:00' },
                { label: '4:30 PM', value: '16:30:00' },
                { label: '5:00 PM', value: '17:00:00' },
                { label: '5:30 PM', value: '17:30:00' },
                { label: '6:00 PM', value: '18:00:00' },
                { label: '6:30 PM', value: '18:30:00' },
                { label: '7:00 PM', value: '19:00:00' },
                { label: '7:30 PM', value: '19:30:00' },
                { label: '8:00 PM', value: '20:00:00' },
                { label: '8:30 PM', value: '20:30:00' },
                { label: '9:00 PM', value: '21:00:00' },
                { label: '9:30 PM', value: '21:30:00' },
                { label: '10:00 PM', value: '22:00:00' },
                { label: '10:30 PM', value: '22:30:00' },
                { label: '11:00 PM', value: '23:00:00' },
                { label: '11:30 PM', value: '23:30:00' },
                { label: '12:00 AM (next day)', value: '00:00:00' },
                { label: '12:30 AM (next day)', value: '00:30:00' },
                { label: '1:00 AM (next day)', value: '01:00:00' },
                { label: '1:30 AM (next day)', value: '01:30:00' },
                { label: '2:00 AM (next day)', value: '02:00:00' },
                { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'EndTime'
        }
    ]
    },
    {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'Event Location',
          mapping: 'SiteName'
      }
    ]
  },
  {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'Address',
          mapping: 'SiteAddress'
      }
    ]
  },
  {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'City',
          mapping: 'SiteCity'
      }
    ]
  },
  {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'Zip Code',
          mapping: 'SitePostal'
      }
    ]
  },
  {
    fields: [
        {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Type of Event*',
        options: [
          { label: 'Business Event', value: 'Business Event' },
          { label: 'Community Event', value: 'Community Event' },
          { label: 'Anniversary', value: 'Anniversary' },
          { label: 'Birthday Party', value: 'Birthday Party' },
          { label: 'Banquet', value: 'Banquet' },
          { label: 'Wedding Reception', value: 'Wedding Reception' },
          { label: 'Other', value: 'Other' },
      ],
        mapping: 'Theme'
    }
]
},
{
  fields: [
    {
      type: 'multiple-choice',
      size: 'Medium',
      label: 'What services are you interested in?',
      options: [
        {label: 'Event Space Rental' , value: 'Event Space Rental' },
        {label: 'Catering Only' , value: 'Catering Only' },
        {label: 'Event Space Rental & Catering' , value: 'Event Space Rental & Catering' },
      ],
      mapping: 'Category'
    }
  ]
},
{
  fields: [
      {
      type: 'multiple-choice',
      size: 'Medium',
      label: 'Catering Service Level Needed*',
      options: [
        { label: 'Drop-Off', value: 'Drop-Off' },
        { label: 'Delivery & Return Service', value: 'Delivery & Return Service' },
        { label: 'Full Service', value: 'Full Service' },
        { label: 'Not Sure', value: 'Not Sure' },
        { label: 'None', value: 'None' },
    ],
      mapping: 'Operation'
  }
]
},
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?*',
            options: [
              { label: 'Google', value: 'Google' },
              { label: 'Event Planner', value: 'Event Planner' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'Facebook', value: 'Facebook' },
              { label: 'Referral', value: 'Referral' },
              { label: 'Other', value: 'Other' },
          ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Additional Event Details',
            mapping: 'notes'

          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          },
        ]
      }
    ]
  },
  info: {
    title: 'Simply Plated Contact Form',
    formId: '828',
    clientKey: 'FB972982-F46F-4F57-90E0-ECDE91A8C0F9',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: '"Thank you for your interest in Simply Plated! A member of our Events Team will be in contact regarding your inquiry within one business day."',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
